module.exports = __webpack_public_path__ + "static/surf-hawaii-ddb59ef68b5e185b3b9dc90c85988458.jpg";